// export const upload_api = {
//   url: '',
//   title: '导入',
//   method: 'post'
// }

// export const export_api = {
//   url: '',
//   title: '导出',
//   method: 'post'
// }

// export const list_api = {
//   url: '',
//   title: '列表',
//   method: 'post'
// }

// export const fileHeader_api = {
//   url: '',
//   title: "",
//   method: "get"
// }
// 搜索，重置，导出，导入
export const actionLine = [
  {
    name: "搜索", index: 1, handler: "handleSearch",
    props: {
      type: "", size: "medium"
    }
  },
  {
    name: "重置", index: 2, handler: "clearSearch",
    props: {
      type: "", size: "medium"
    }
  },
  {
    name: "导出", index: 3, handler: "handleExport",
    props: {
      type: "primary", size: "medium"
    }
  },
  {
    name: "导入", index: 4, handler: "handleImport",
    props: {
      type: "primary", size: "medium"
    }
  },
];


// WEBPACK FOOTER //
// ./src/views/canmou/shoptotalmonth/desc.js